import styled from 'styled-components';

export const FlexCenter = styled.div`
  display: flex;
  justify-content: center;
`;
